<template>
    <div v-if="isShowConfirm">
        <transition name="ryt-transition">
           <div :class="['container', { 'container-dark': theme_dark }]" >
                <div class="title ub ub-ver ub-pc">
                    <img class="close" @click="closeRytDropdown()" src="../assets/img/关闭 (2).png" alt="">
                    <span class="sp1">恭喜你获得</span>
                    <span class="sp2">首充大礼包</span>
                </div>

                <div class="gift_pack-block ub">
                    <div class="gift_pack ub ub-ver">
                        <ul class="ub ub-ac1">
                            <li class="item ub ub-ver ub-pc ub-ac ub-f1" v-for="(item, index) in arr" :key="index"  @click="chose_giftPack(item.mny)" :class="chosed == item.mny ? 'on' : ''">
                                <span>{{ item.act_name }}</span>
                                <a>价值{{ item.mny_old }}元</a>
                            </li>
                        </ul>

                        <div class="giftPack_info ub ub-ac3">
                            <div class="vip_block ub ub-ver ub-ac2 ub-pc">
                                <div class="tag ub ub-ac ub-pc">{{ chosed_item.vip_mny }} 元</div>
                                <div class="ub ub-pc ub-ac">
                                    <img src="../assets/img/会员.png" />
                                </div>
                                <span class="ub ub-ac ub-pc">{{ chosed_item.name }}会员</span>
                            </div>
                            <div class="jia ub ub-ac ub-pc">+</div>
                            <div class="coin_block ub ub-ver ub-ac2 ub-pc">
                                <div class="tag ub ub-ac ub-pc">{{ chosed_item.coin_mny }} 元</div>
                                <div class="ub ub-pc ub-ac">
                                    <img v-if="chosed_item.lv == 21" src="../assets/img/一堆金币.png" />
                                    <img v-if="chosed_item.lv > 21" src="../assets/img/一堆金币2.png" />
                                </div>
                                <span class="ub ub-ac ub-pc">{{ chosed_item.coin }}金币</span>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="btn-block">
                    <div class="btn ub ub-ac ub-pc" @click="pay_vip(chosed_item)">立即支付{{pay_mny}}元领取</div>
                </div>
            </div>
        </transition>
        <dlg ref="myForm" @formBehavior="formBehaviorFun"></dlg>
       </div>
</template>

<script>
import * as tool from '../api/common';
import { mapMutations, mapActions } from "vuex";
import Form from "./Form.vue";
   export default {
       name: "FirstCharge",
        components: {
            dlg: Form,
        },
       data() {
           return {
               isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
               theme_dark: false,
               chosed: 3,
               chosed_item: {
                    "vip_type": "VIP",
                    "vip_time": 1,
                    "name": "1天",
                    "mny": 3,
                    "mny_old": 18.8,
                    "vip_mny": 8.8,
                    "coin": 2000,
                    "coin_mny": 10,
                    "lv": 21
                },
               arr:[],
               pay_mny: 3
           }
       },
       methods: {
        ...mapMutations(["get", "post", "WxConfig", "WxPay"]), //引入方法
        ...mapActions(["act_get_userinfo", "act_reload_userinfo"]), //引入方法

        show () {
            //切换深色模式
            this.theme_dark = tool.is_theme_dark(this);
      
            this.isShowConfirm = true;
            this.init_page();
            this.init_page_pay();
          },

          hidden () {
            this.isShowConfirm = false
          },

           closeRytDropdown() { //关闭子组件
               this.isShowConfirm = false;
           },
           chose_giftPack(chose_item) {
            this.chosed = chose_item;
            var item;
            for (var i = 0; i < this.arr.length; i++) {
                item = this.arr[i];
                if (item.mny == chose_item) {
                    this.chosed_item = item;
                    this.pay_mny = item.mny;
                }
            }
           },

           init_page() {
            //使用缓存数据
            var first_charge = this.$store.state.objVal.first_charge;
            if (first_charge.length > 0) {
                this.arr = first_charge;
                this.chosed_item = first_charge[0];
                return false;
            }

            var uid = this.$store.state.uid;
            var self = this;
            //加载配置数据
            self.get({
                    url: "/App/GetCnfigMem_First/?uid=" + uid,
                    success: function (data) {
                        self.arr = data;
                        self.$store.commit('set_objVal', {"first_charge": data});
                        self.chosed_item = data[0];
                    },
                });
                
            },

           init_page_pay() {
                this.WxConfig({url:window.location.href});
            },

           pay_vip(item) {
            //启动动画
            this.$loading("支付中...");

            //获取 openid
            var openid = this.$store.state.openid;
            if (!openid) {
                if ($cookies.isKey("openid")) {
                openid = $cookies.get("openid");
                }
            }

            //获取 order_from
            var order_from = "";
            var client = this.$store.state.client;
            if (client.is_wx) {
                if (openid) {
                order_from = "微信公众号支付";
                } else {
                order_from = "微信环境无openid";
                }
            } else {
                order_from = "非微信环境";
                //给弹出提示
                this.Show_GuanzhuWx();
            }

            var uid = this.$store.state.uid;

            var self = this;
            var send_data = {
                order_name: item.act_name,
                order_mny: item.mny,
                vip_type: item.vip_type,
                vip_time: item.vip_time,
                comment: item.lv,
                uid: uid,
                order_from: order_from,
                out_id: openid,
                order_type: "购买会员",
                order_type2:"首充活动"
            };

            var sendData = JSON.stringify(send_data);
            console.log(sendData);

            var parm_data = {
                url: "/App/Create_Order",
                data: { data: sendData },
                success: function (data_serve) {
                //消掉动画
                self.$loading.close();
                if (data_serve.state != "1") {
                    self.$toast.center("订单生成失败,请重新下单");
                    return false;
                }
                var data_pay = {
                    body: send_data.order_name,
                    out_trade_no: data_serve.msg,
                    totalMoney: item.mny * 100,
                    openid: openid,
                };
                //console.log(JSON.stringify(data_pay));
                self.checkUid();
                self.pay(data_pay);
                },
                error: function (data_serve) {
                //消掉动画
                self.$loading.close();
                },
            };

            self.post(parm_data);
           },

           pay(data) {
            var self = this;
            var strSend = JSON.stringify(data);
            var data = {
                strSend: strSend,
                success: function (res) {
                //提示支付成功,刷新用户信息
                setTimeout(() => {
                    self.$toast.center("购买成功~");
                    self.isShowConfirm = false;
                    self.act_reload_userinfo();
                }, 500);
                },
                cancel: function (res) {},
                fail: function (res) {},
            };

            //检测是否微信环境，是微信环境进行微信支付
            var client = this.$store.state.client;
            if (client.is_wx) {
                this.WxPay(data);
            }
          },

           checkUid() {
                var uid = this.$store.state.uid;
                //支付检测uid
                if (uid == null || uid == "" || uid == "undefined") {
                    var keys = this.$cookies.keys();
                    for (var i in keys) {
                    this.$cookies.remove(keys[i]);
                    }
                }
            },

           Show_GuanzhuWx() {
                var qrcode_url = require("../assets/img/qrcode_xhc.jpg");
                var gzh_name = "小火柴";
                //加载dic信息
                var sysdic = this.$store.state.sysdic;
                if (sysdic) {
                    qrcode_url = sysdic.wx_gzh_qrcode;
                    gzh_name = sysdic.wx_gzh_name;
                }
                var h =
                    '<div class="dlg-note">为了保证您的资金安全，当前只支持微信环境下支付，请先关注微信公众号<div>' +
                    '<div class="ub ub-ac ub-pc dlg-img"><img src="' +qrcode_url +'" /></div>';
                this.$refs.myForm.show(h, {
                    type: "alert",
                    confirmText: "微信扫描上方二维码",
                    titleText: "温馨提示",
                    data: "",
                });
            },
            formBehaviorFun(type, data) {
                if (type == "clickConfirm") {
                }
            },
       },

   }
</script>
<style lang="scss" scoped>
.container {
    position: fixed;
    bottom: 0;
    left: 50%;
    width: 100%;
    background: linear-gradient( 180deg, #A264E7, #FE9CC0);
    border-top-right-radius: 1rem;
    border-top-left-radius: 1rem;
    transform: translate3d(-50%, 0, 0);
    backface-visibility: hidden;
    transition: transform .3s ease-out;
    z-index: 998;
    padding-top: 0.5rem;
}
.title {
    position: relative;
    span {
        color: #FFEAB8;
        font-weight: bold;
    }
    .sp1 {
        margin-top: 0.5rem;
        font-size: 1.5rem;
    }
    .sp2 {
        font-size: 2rem;
    }
    .close {
        position: absolute;
        top: 0.5rem;
        left: 0.5rem;
        width: 1.5rem;
        height: 1.5rem;
    }
}
.gift_pack-block {
    margin-top: 1.5rem;
    padding: 0.5rem 0.8rem;
    .gift_pack {
        padding-bottom: 1rem;
        width: 100%;
        border-radius: 1rem;
        background-color: #FDFDFD;
        ul {
            width: 100%;
            background-color: #FFDBDF;
            border-top-left-radius: 1rem;
            border-top-right-radius: 1rem;
            .item {
                height: 3rem;
                border-top-left-radius: 1rem;
                border-top-right-radius: 1rem;
                span {
                    font-size: 1rem;
                    font-weight: bold;
                    color: #8E3C40;
                }
                a {
                    font-size: 0.65rem;
                    color: #81504A;
                }
            }
            .on {
                margin-top: -1rem;
                height: 4rem;
                background-color: #FDFDFD;
                
            }
        }
    }

    .giftPack_info {
        margin-top: 1rem;
        width: 100%;
        .vip_block {
            position: relative;
            width: 40%;
            height: 11rem;
            background-color: #FFE4E9;
            border-radius: 0.5rem;
            .tag {
                position: absolute;
                top: 0;
                right: 0;
                padding: 0.1rem 0.4rem;
                background: linear-gradient( 90deg, #FDBABE, #FF869E);
                border-bottom-left-radius: 0.5rem;
                border-top-right-radius: 0.5rem;
                font-size: 0.75rem;
                color: #fff;
                
            }
            img {
                margin-top: 1rem;
                width: 70%;
            }
            span {
                width: 100%;
                height: 2rem;
                border-bottom-left-radius: 0.5rem;
                border-bottom-right-radius: 0.5rem;
                background-color: #FFCCD3;
                color: #903A44;
                font-size: 1rem;
            }
        }
        .jia {
            font-size: 2rem;
            font-weight: bold;
            color: #903A44;
        }
        .coin_block {
            position: relative;
            width: 40%;
            height: 11rem;
            background-color: #FFE4E9;
            border-radius: 0.5rem;
            .tag {
                position: absolute;
                top: 0;
                right: 0;
                padding: 0.1rem 0.4rem;
                background: linear-gradient( 90deg, #FDBABE, #FF869E);
                border-bottom-left-radius: 0.5rem;
                border-top-right-radius: 0.5rem;
                font-size: 0.75rem;
                color: #fff;
                
            }
            img {
                margin-top: 1rem;
                width: 80%;
            }
            span {
                width: 100%;
                height: 2rem;
                border-bottom-left-radius: 0.5rem;
                border-bottom-right-radius: 0.5rem;
                background-color: #FFCCD3;
                color: #903A44;
                font-size: 1rem;
            }
        }
    }
}
.btn-block{
    padding: 0.5rem 0.8rem;
    margin-bottom: 1rem;
    text-align: center;
    .btn {
        height: 3rem;
        font-size: 1rem;
        border-radius: 1.4rem;
        color: #fff;
        line-height: 1.5rem;
        background-color: #A264E7;
    }
}

/*弹窗动画*/
.ryt-transition-enter,
.ryt-transition-leave-active {
   transform: translate3d(-50%, 100%, 0);
   transition: transform 0.6s ease-in-out;
}    
</style>
